export default "__VITE_ASSET__eEfz9VlS__"